import {useListView} from '../../core/ListViewProvider'
import {TriggersListToolbar} from './TriggersListToolbar'
import {TriggersListSearchComponent,} from './TriggersListSearchComponent'
import { TriggersListGrouping } from './TriggersListGrouping'

const TriggerListsHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <TriggersListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <TriggersListGrouping /> : <TriggersListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {TriggerListsHeader}
